import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Link from "next/link";
import Button from "components/Button";

const OuterBannerWrapper = styled.section`
  background-color: ${({ theme }) => theme.themeColors.primary};
  margin: 5.625rem 0 0 0;
`;

const ContentWrapper = styled.div`
  padding: 4.625rem 1.5625rem;

  ${({ theme }) => theme.mq.lg`
    padding: 6.25rem 1.5625rem;
  `}
`;

const ContentCallout = styled.h2`
  color: ${({ theme }) => theme.themeColors.lightGreen3};
  font-size: 2.375rem;
  letter-spacing: -0.066875rem;
  line-height: 1.13125;
  margin: auto;
  padding-bottom: 0.5625rem;

  ${({ theme }) => theme.mq.xs`
    text-align: center;
  `}

  ${({ theme }) => theme.mq.lg`
    font-size: 3.125rem;
    line-height: 1.1;
    width: 47.75rem;
  `}
`;

const ContentCopy = styled.p`
  color: ${({ theme }) => theme.themeColors.lightGreen3};
  font-size: ${({ theme }) => theme.fontSize(2)};
  line-height: 1.3125;
  margin: auto;
  padding-bottom: 2.1875rem;
  text-align: center;

  ${({ theme }) => theme.mq.md`
    width: 100%
  `}

  ${({ theme }) => theme.mq.lg`
    width: 45rem;
  `}
`;

const ButtonWrapper = styled.a`
  display: flex;
  margin: 0 auto;
  width: 100%;

  ${({ theme }) => theme.mq.sm`
    max-width: 12.5625rem;
  `}
`;

function TextAndButton({ buttonLink, buttonText, callOutText, copy }) {
  return (
    <OuterBannerWrapper>
      <ContentWrapper>
        <ContentCallout>{callOutText}</ContentCallout>
        <ContentCopy>{copy}</ContentCopy>
        <Link href={buttonLink} passHref>
          <ButtonWrapper>
            <Button colorType="lightGreen3" textColor="primary">
              {buttonText}
            </Button>
          </ButtonWrapper>
        </Link>
      </ContentWrapper>
    </OuterBannerWrapper>
  );
}

export default TextAndButton;

TextAndButton.propTypes = {
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  callOutText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  copy: PropTypes.string,
};

TextAndButton.defaultProps = {
  buttonLink: "/",
  buttonText: "",
  callOutText: {},
  copy: "",
};
